import React from 'react';

import { useTranslation } from '@modernloop/i18n';
import { CopyIcon, JumpIcon } from '@modernloop/shared/icons';
import { ListItemIcon, MenuItem, Typography } from '@mui/material';

import { enviromentConfig } from 'src/config';

import useCopyDebugInfo from './useCopyDebugInfo';

/** ModernLoop-only diagnostics and environment actions shown inside the Employee account menu. */
const AccountMenuDeveloperItems = (): JSX.Element => {
  const { t } = useTranslation();
  const handleCopyDebugInfo = useCopyDebugInfo();
  const { environment } = enviromentConfig;
  const isStaging = environment?.toLowerCase() === 'staging';
  const isDeployPreview = window.location.hostname.includes('deploy-preview');

  const handleLinkToolClick = () => {
    const path = window.location.pathname;
    const searchString = window.location.search;
    if (isStaging && !isDeployPreview) {
      window.open(`http://localhost:8888${path}${searchString}`);
      return;
    }

    window.open(`https://appstg.modernloop.io${path}${searchString}`);
  };

  return (
    <>
      <MenuItem id="app-nav-copy-debug-info" data-testid="app-nav-copy-debug-info" onClick={handleCopyDebugInfo}>
        <ListItemIcon>
          <CopyIcon />
        </ListItemIcon>
        <Typography>{t('hiring-dashboard-nav:nav.debugInfo.label')}</Typography>
      </MenuItem>
      <MenuItem id="app-nav-dev-tools-jump" data-testid="app-nav-dev-tools-jump" onClick={handleLinkToolClick}>
        <ListItemIcon>
          <JumpIcon />
        </ListItemIcon>
        <Typography>
          {isStaging && !isDeployPreview
            ? t('hiring-dashboard-dev-tools:dev-tools.openInLocalhost')
            : t('hiring-dashboard-dev-tools:dev-tools.openInStaging')}
        </Typography>
      </MenuItem>
    </>
  );
};

export default AccountMenuDeveloperItems;
